import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { ApiSysService } from '@core/api/api-sys.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const authRedirectGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const apiSysService = inject(ApiSysService);

  if (!auth.isLoggedIn()) {
    auth.login(state.url);
    return false;
  }

  return apiSysService.getPersonnelPreferences(auth.getUserId()).pipe(
    map(preferences => router.createUrlTree([preferences?.preferred_url ?? '/landing'])),
    catchError(() => of(router.createUrlTree(['/landing'])))
  );
};
